import React from 'react';
import { useParams } from 'react-router-dom';

export function AcceptInvitationPage() {
  const { token } = useParams<{ token: string }>();

  React.useEffect(() => {
    if (token) {
      const apiBase = import.meta.env.VITE_API_URL;
      window.location.assign(`${apiBase}/invitations/accept?token=${encodeURIComponent(token)}`);
    } else {
      // No token present: send back to login
      window.location.assign(`/`);
    }
  }, [token]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p>Accepting your invitation...</p>
    </div>
  );
}
